<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="所属基地" prop="land_base_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.land_base_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="地块编号" prop="sn">
              <Input disabled="disabled" class="perW30" v-model="infoData.sn"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="地块面积(亩)" prop="area">
              <Input disabled="disabled" v-model="infoData.area" class="perW20"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="负责人" prop="leader">
              <Input disabled="disabled" class="perW30" v-model="infoData.leader"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="联系电话" prop="phone">
              <Input disabled="disabled" class="perW30" v-model="infoData.phone"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="所属村" prop="village">
              <Input disabled="disabled" class="perW30" v-model="infoData.village"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="村民数量" prop="villager_num">
              <Input disabled="disabled" v-model="infoData.villager_num" class="perW20"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="位置信息" prop="location">
              <Input disabled="disabled" class="perW60" v-model="infoData.location"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="周边环境" prop="contents">
              <div style="border: 1px solid #e9e9e9;border-radius: 10px;padding: 10px;">
                <div v-html="infoData.contents"></div>
              </div>
            </FormItem>
          </Col>

        </Row>
      </Form>
    </card>

  </div>
</template>
<script>
import {landInfoInfoApi} from '@/api/landBase/landInfo'

export default {
  name: 'landInfoInfo',
  data() {
    return {
      infoData: {
        id: 0,
        sn: '',
        land_base_name: '',
        area: 0,
        leader: '',
        phone: '',
        village: '',
        villager_num: 0,
        location: '',
        contents: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {

    // 加载数据
    loadInfoData(id) {
      landInfoInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
